// src/CreateCustomerPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PopupMessage from '../components/PopupMessage';
import { Link } from "react-router-dom";
import CustomerForm from '../components/CustomerForm';
import Preferences from '../components/Preferences';
import LivePreview from '../components/LivePreview';


const initialCustomerData = {
  fullName: '', phoneNumber: '', serviceNumber: '',
  dueDate: '', maxDailyMessages: 100, 
   digit_format: 'english'
};

function CreateCustomerPage({ onLogout }) {
  // ✅ 2. تابع navigate را مقداردهی اولیه کنید
  const navigate = useNavigate();

const styles = {
    mainContainer: { 
        maxWidth: '938px', // Was 1400px
        width: '100vw',
        margin: '1.34rem auto', // Was 2rem
        boxShadow: '0 3px 8px rgba(0,0,0,0.1)', // Was 0 4px 12px
        borderRadius: '5px', // Was 8px
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 2.68rem)', // Was calc(100vh - 4rem)
    },
    container: { 
        display: 'flex', 
        width: '100%', 
        direction: 'rtl', 
        flex: 1,
        overflow: 'hidden'
    },
    column: { 
        padding: '1rem', // Was 1.5rem
        boxSizing: 'border-box',
        backgroundImage: 'linear-gradient(270deg, #353535, #687b92)',
        color: 'white',
        overflowY: 'auto'
    },
    rightColumn: { 
        flex: '0 0 25%', 
        borderLeft: '1px solid #ddd', // Borders are kept at 1px for sharpness
        borderRadius:'0 20px 0 0', // Was 30px
    },
    middleColumn: { 
        flex: '0 0 50%', 
        borderLeft: '1px solid #ddd', // Borders are kept at 1px for sharpness
    },
    leftColumn: { 
        flex: '0 0 25%',
        borderRadius:'20px 0 0 0', // Was 30px
    },
    saveButtonContainer: { 
        padding: '0.67rem 1rem', // Was 1rem 1.5rem
        borderTop: '1px solid #ddd', // Borders are kept at 1px for sharpness
        backgroundColor: '#000000ff',
        display: 'flex',
        gap: '0.67rem', // Was 1rem
    },
    finalSaveButton: { 
        backgroundColor: '#28a745', 
        color: 'white', 
        border: 'none', 
        padding: '0.67rem', // Was 1rem
        borderRadius: '5px', // Was 8px
        cursor: 'pointer', 
        fontSize: '0.8rem', // Was 1.2rem
        width: '100%',
        textAlign: 'center',
    },
    cancelButton: {
        backgroundColor: '#6c757d',
        color: 'white',
        border: 'none',
        padding: '0.5rem 0.67rem', // Was 0.75rem 1rem
        borderRadius: '5px', // Was 8px
        cursor: 'pointer',
        fontSize: '0.74rem', // Was 1.1rem
        width: '100%',
        textAlign: 'center',
        textDecoration: 'none',
        display: 'block',
    },
    loadingText: { 
        textAlign: 'center', 
        fontSize: '1rem', // Was 1.5rem
        color: '#555', 
        padding: '3.35rem' // Was 5rem
    }
};
  
  const [customerData, setCustomerData] = useState(initialCustomerData);
  const [preferencesData, setPreferencesData] = useState({ groups: [] });
  const [popup, setPopup] = useState({ message: '', type: '' });
  const [isLoading, setIsLoading] = useState(true);

  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [isPhoneFocused, setIsPhoneFocused] = useState(false);
  const PHONE_REGEX = /^09\d{9}$/;
  const [selectedGroup, setSelectedGroup] = useState('');
 useEffect(() => {
    setIsPhoneValid(PHONE_REGEX.test(customerData.phoneNumber));
  }, [customerData.phoneNumber]);

  useEffect(() => {
    const fetchPreferences = async () => {
      try {
        const response = await fetch('https://tgnsys.ir/WS/GetGroups');
        if (!response.ok) throw new Error('Network response was not ok');
        const apiData = await response.json();
        const activeGroups = apiData.filter(group => !group.TitleFa.includes("(api") && !group.TitleFa.includes("(غیرفعال)"));
        const transformedData = {
          groups: activeGroups.map(group => ({
            group_number: group.Number,
            group_title: group.TitleFa,
            items: group.items.map(item => ({
              item_char: item.Symbol,
              item_title: item.TitleFa,
              is_selectable: false,
              is_visible: false,
              item_sign: "",
              currency: 'تومان',
              coefficient: 1,
              rounding_policy: 'round_100',
            }))
          }))
        };
        setPreferencesData(transformedData);
      } catch (error) {
        console.error("Failed to fetch preferences:", error);
        setPopup({ message: 'خطا در دریافت تنظیمات اولیه از سرور.', type: 'error' });
      } finally {
        setIsLoading(false);
      }
    };
    fetchPreferences();
  }, []);

  const handleFinalSave = async () => {
    if (!customerData.fullName || !customerData.phoneNumber) {
      setPopup({ message: 'لطفاً نام و شماره تلفن مشتری را وارد کنید.', type: 'error' });
      return;
    }
    if (!isPhoneValid) {
        setPopup({ message: 'لطفاً یک شماره تلفن معتبر وارد کنید.', type: 'error' });
        return;
    }
    setPopup({ message: 'در حال ارسال...', type: 'info' });
    const token = localStorage.getItem('token');
    if (!token) {
        onLogout(); // Log out if token is missing
        return;
    }
    const preferencesToSend = [];
    preferencesData.groups.forEach(group => {
        group.items.forEach(item => {
            if (item.is_visible || item.is_selectable) {
                preferencesToSend.push({ ...item, group_number: group.group_number, group_title: group.group_title });
            }
        });
    });
    try {
        const response = await fetch('https://interactivebot.tgnsys.ir/api/create_customer.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' ,
               'Authorization': `Bearer ${token}` 

             },
            body: JSON.stringify({ customer: customerData, preferences: preferencesToSend })
        });
        const result = await response.json();
        if (response.ok) {
            setPopup({ message: result.message, type: 'success' });
            // ✅ 3. پس از موفقیت، کاربر را به صفحه اصلی هدایت کنید
            setTimeout(() => navigate('/'), 2000); // 2 ثانیه تاخیر برای نمایش پیام موفقیت
        } else {
            setPopup({ message: result.message || 'یک خطای ناشناخته در سرور رخ داد.', type: 'error' });
        }
    } catch (error) {
        setPopup({ message: `خطای ارتباطی: ${error.message}`, type: 'error' });
    }
  };

  if (isLoading) {
    return <div style={styles.loadingText}>در حال بارگذاری تنظیمات...</div>;
  }

  return (
    <div style={styles.mainContainer}>
      
      <PopupMessage message={popup.message} type={popup.type} onClose={() => setPopup({ message: '', type: '' })} />
      <div style={styles.container}>
        <div style={{ ...styles.column, ...styles.rightColumn }}>
          <CustomerForm 
            customerData={customerData} onCustomerChange={setCustomerData}
            isPhoneValid={isPhoneValid} isPhoneFocused={isPhoneFocused}
            onPhoneFocus={() => setIsPhoneFocused(true)} onPhoneBlur={() => setIsPhoneFocused(false)}
          />
        </div>
        <div style={{ ...styles.column, ...styles.middleColumn }}>
        <Preferences 
    preferences={preferencesData} 
    onPreferencesChange={setPreferencesData}
    selectedGroup={selectedGroup}
    onGroupChange={setSelectedGroup} // ✅ Add this line
/>
        </div>
        <div style={{ ...styles.column, ...styles.leftColumn }}>
          <LivePreview preferences={preferencesData} onPreferencesChange={setPreferencesData} />
        </div>
      </div>
      <div style={styles.saveButtonContainer}>
            <Link to="/" style={styles.cancelButton}>
                انصراف
            </Link>
            <button style={styles.finalSaveButton} onClick={handleFinalSave}>
                به‌روزرسانی اطلاعات مشتری
            </button>
        </div>
    </div>
  );
}

export default CreateCustomerPage;